import {
  getToken
} from "@/util/auth";

import {
  GetConsultationByInquisitionId,
  GetPatientInfoByConsultaionId,
  GetMyConsultationByPara
} from '@/api/modules/basicData/remoteConsultation';

const cookieUser = getToken();

export default {
  state: {
    consultationList: [], //会诊列表
    curRow: {}, //当前选中行
    loading: false,
    chatInfo: '',//接受消息
    unReadChat: '',//未读消息
    showReportDialog: false,//是否填写报告单
    paientInfo: [],//患者列表信息
    freshFlag: false,//刷新卡片数据
    freshTable: false,//刷新列表数据
    viewType: false,//判断显示表格还是显示卡片
  },
  mutations: {
    setViewType(state, viewType) {
      state.viewType = viewType;
    },
    setfreshTable(state, freshTable) {
      state.freshTable = freshTable;
    },
    setfreshFlag(state, freshFlag) {
      state.freshFlag = freshFlag;
    },
    setPaientInfo(state, paientInfo) {
      state.paientInfo = [];
      state.paientInfo = paientInfo;
    },
    setUnReadChat(state, unReadChat) {
      state.unReadChat = unReadChat;
    },
    setReport(state, report) {
      // console.log("设置填写报告单弹出层1",report)
      state.showReportDialog = report;
    },
    setChatInfo(state, chatInfo) {
      state.chatInfo = chatInfo;
    },
    //设置当前行
    setCurConsultationRow(state, row) {
      state.curRow = row;
    },
    refreshConsultation(state, list) {
      state.consultationList = list;
    },
    newConsultation(state, newRow) {
      // console.log("执行----newConsultation")
      let arr = [...state.consultationList];
      arr.unshift(newRow);
      state.consultationList = arr;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    //置顶
    stickyConsultation(state, row) {
      for (let i = 0; i < state.consultationList.length; i++) {
        if (row.ID == state.consultationList[i].ID) {
          // if(i==0){
          //   state.curRow = row; //选中
          //   return false
          // }else{
          state.consultationList.splice(i, 1); // 如果数据组存在该元素，则把该元素删除
          state.consultationList.unshift(row); // 再添加到第一个位置
          state.curRow = row; //选中
          return false
          // }
        }
      }

    },

  },
  actions: {
    /**
     * 设置当前会诊
     * @param {} param0 
     * @param {*} row 
     */
    setCurConsultation({ commit, state }, row) {
      console.log(commit)
      commit("setCurConsultationRow", row);
      GetPatientInfoByConsultaionId(row.ID).then((res) => {
        if (res && res.length > 0) {
          commit("setPaientInfo", res);
        }
      });

    },
    //置顶会诊
    stickyConsultation({
      commit,
      state
    }, inquisitionId) {
      var row = state.consultationList.find(o => o.INQUISITIONID == inquisitionId);
      console.log("置顶会诊", row)
      if (row) {
        console.log("stickyConsultation", row);
        commit("stickyConsultation", row);
        commit('setfreshFlag', true)
      } else {

        GetConsultationByInquisitionId(inquisitionId).then(result => {
          if (result) {
            if (state.viewType) {
              console.log("newConsultation", result);
              commit("newConsultation", result);
            } else {
              commit("newConsultation", result);
              commit("setCurConsultationRow", result);
              // commit('setfreshTable', true);
            }

          }
        });

      }

    },
    //置顶定位
    stickyLocateConsultation({
      commit,
      state
    }, inquisitionId) {
      var row = state.consultationList.find(o => o.INQUISITIONID == inquisitionId);
      console.log("置顶定位stickyLocateConsultation", row)
      GetConsultationByInquisitionId(inquisitionId).then(result => {
        if (result) {
          console.log("setCurConsultationRow", result);
          if (row) {
            console.log("stickyLocateConsultation", result);
            commit("stickyConsultation", result);
            commit('setfreshFlag', true);
            commit('setfreshTable', true);
          } else {
            commit("newConsultation", result);
            commit("setCurConsultationRow", result);
          }
        }
      });

    },
    //刷新会诊
    refreshConsultation({
      commit
    }, INQUISITIONID) {
      commit("setLoading", true);
      //loadRemindInfo();刷新提醒
      // console.log("执行刷新会诊")
      GetMyConsultationByPara({
        PageIndex: -1,
        CurrentUserId: cookieUser.userId
      })
        .then(result => {
          // console.log("刷新会诊返回结果result",result)
          commit("refreshConsultation", result.Items);
          if (result.Items.length > 0) {
            commit("setCurConsultationRow", result.Items[0]);
          }
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
    // 启动会诊   
    startConsultation({
      dispatch,
      commit
    }, inquisitionId) {
      StartMeetRemote(
        cookieUser.userId,
        inquisitionId
      ).then(res => {
        if (res.ResultCode == 1) {
          this.$message({
            message: "正在启动视频,请稍等",
            type: "success"
          });
          dispatch("refreshConsultation");
        } else {
          this.$message({
            message: res.MsgInfo,
            type: "启动视频失败"
          });
        }
      });
    },
    //会诊即将开始
    comingConsultation({
      commit,
      state
    }, inquisitionId) {
      // 如果不在列表中，先加入到列表中   置顶
      let row = state.consultationList.find(o => o.INQUISITIONID == inquisitionId);
      if (row) {
        commit("stickyConsultation", row);
      } else {
        GetConsultationByInquisitionId(inquisitionId).then(result => {
          if (result) {
            commit("newConsultation", result);
          }
        });
      }
    }
  }
};
